<template>
  <section class="case">
    <section class="content_section fix_width">
      <h2>业界成功案例</h2>
      <div class="success_block">
        <div class="case-layout">
          <img src="../assets/c1.png">
          <p class="case-subtitle">杏彩娱乐</p>
        </div>
        <div class="case-layout">
          <img src="../assets/c4.png">
          <p class="case-subtitle">摩臣娱乐</p>
        </div>
        <div class="case-layout">
          <img src="../assets/c3.png">
          <p class="case-subtitle">恒彩娱乐</p>
        </div>
        <div class="case-layout">
          <img src="../assets/c2.png">
          <p class="case-subtitle">杏鑫娱乐</p>
        </div>
        <div class="case-layout">
          <img src="../assets/c5.png">
          <p class="case-subtitle">圣耀娱乐</p>
        </div>
      </div>
    </section>
    <section class="content_section fix_width">
      <h2>简约直观的界面</h2>
      <div class="ui_block">
        <div class="img_box">
          <img class="case-img" @click="handleImgClick" src="../assets/ca1b.png">
          <p>7*24真人客服协助客户付款</p>
        </div>
        <div class="img_box">
          <img class="case-img" @click="handleImgClick" src="../assets/ca2b.png">
          <p>充值界面</p>
        </div>
        <div @click="handleHideImg" v-if="showPic" class="show-container">
          <div class="show-layout">
            <div class="scale_img">
              <img :src="showBig">
            </div>
            <img class="case-close" src="../assets/close.png">
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<style lang="less" scoped>
@import '../css/common.less';
.success_block{
  margin-top: 40px;
  .case-layout {
    display: inline-block;
    margin: 0 15px;
    padding: 15px;
    box-shadow: 2px 4px 10px rgba(0,0,0,.2);
    img{width: 7.778em;}
    .case-subtitle {
      color: #1e1e1e;
      font-size: 18px;
      margin: .6em 0;
    }
  }
}
.ui_block{
  margin-top: 40px;
  .case-close {
    position: absolute;
    width: 28px;
    top: -26px;
    right: -26px;
  }
  .img_box{
    display: inline-block;
    margin: 0 15px;
    .case-img {
      width: 400px;
      border: 3px #d1d1d6 solid;
    }
    p{
      font-size: 0.89em;
      letter-spacing: 0.44px;
      text-align: left;
      margin: .8em 0 0;
    }
  }
  .show-container {
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    position: fixed;
    background:rgba(0, 0, 0, 0.4);
    .show-layout {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -20vw;
      margin-left: -30vw;
      cursor: pointer;
      .scale_img{
        width: 56vw;
        height: auto;
        position: relative;
        margin: 0 auto;
        img{width: 100%;}
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  .success_block{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 2em;
    .case-layout {
      width: auto;
      display: inline-block;
      margin: 0 1em 1.5em;
      padding: 1em;
      box-shadow: .1em .2em .5em rgba(0,0,0,.2);
      img{width: 6.6em;}
      .case-subtitle {
        color: #1e1e1e;
        font-size: 1em;
        margin: .6em 0;
      }
    }
  }
  .ui_block{
    margin-top: 2em;
    margin-bottom: 1em;
    .case-close {
      position: absolute;
      width: 3em;
      top: -3em;
      right: -3em;
    }
    .img_box{
      display: inline-block;
      margin: 0 2em;
      .case-img {
        width: 15em;
        border: 3px #d1d1d6 solid;
      }
      p{
        font-size: 0.9em;
        letter-spacing: 0.44px;
        text-align: left;
        margin: .6em 0 0;
      }
    }
    .show-container {
      z-index: 99;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      position: fixed;
      background:rgba(0, 0, 0, 0.6);
      .show-layout {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -36vw;
        margin-left: -42vw;
        cursor: pointer;
        .scale_img{
          width: 80vw;
          height: auto;
          position: relative;
          margin: 0 auto;
          img{width: 100%;}
        }
      }
    }
  }
}
@media screen and (max-width: 767.9px) {
  .success_block{
    margin-top: 1.5em;
    .case-layout {
      margin: 0 .5em 1.2em;
      padding: .8em;
      box-shadow: .1em .2em 1em rgba(0,0,0,.2);
      img{
        width: 19vw;
      }
      .case-subtitle {
        font-size: 1em;
        margin: 1em 0 0;
      }
    }
  }
  .ui_block{
    margin-top: 1.5em;
    .case-close {
      position: absolute;
      width: 2.3em;
      top: -3.6em;
      right: 50%;
      margin-right: -1.15em;
      z-index: 1000;
    }
    .img_box{
      margin: 0 .6em;
      .case-img {
        width: 38vw;
        border: 2px #d1d1d6 solid;
      }
      p{
        font-size: 0.8em;
        letter-spacing: 0;
        text-align: center;
        margin: .5em 0 0;
      }
    }
    .show-container {
      .show-layout {
        left: 3vw;
        margin-top: -24vh;
        margin-left: 0;
        .scale_img{
          width: 94vw;
        }
      }
    }
  }
}
</style>

<script>
export default {
  data () {
    return {
      showPic: false,
      showBig: ''
    }
  },
  methods: {
    handleImgClick (img) {
      this.showBig = img.target.src || img.srcElement.src
      this.triggerShowPic()
    },
    handleHideImg () {
      this.triggerShowPic()
    },
    triggerShowPic () {
      this.showPic = !this.showPic
    }
  }
}
</script>
